// extracted by css-extract-rspack-plugin
export default {"root":"QxQArM5qNPcazm0E","avatar":"RuMKiMVgsjqqLXQt"};